import React, { useState } from 'react';
import './faq.css';
import { useNavigate, useParams } from 'react-router-dom';
import Dialog from '../../dialogModal/dialogModal';

export default function FAQ({ data, page, handleDelete, rowClickId, setRowClickId, deleteModal, setDeleteModal }) {
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(null);
    const { mode } = useParams();

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div>
            {data?.map((faqdata, faqIndex) => (
                <div className='faqContainer' key={faqIndex}>
                    <div className='faqItem'>
                        <div className='faqQuestion alignCenter' onClick={() => toggleAccordion(faqIndex)}>
                            <span>{faqdata.question}</span>
                            <span className='icon'>{activeIndex === faqIndex ? '-' : '+'}</span>
                        </div>
                        <div className={`faqAnswer ${activeIndex === faqIndex ? 'active' : ''}`}>
                            {activeIndex === faqIndex && <p>{faqdata.answer}</p>}
                        </div>
                    </div>
                    {page === 'support' && (
                        <div className='faqBtn'>
                            <button
                                className='actBtn payoutBtn noWidth'
                                onClick={() =>
                                    navigate(`/support/${mode}/faq/upload`, {
                                        state: { faqdata }
                                    })
                                }
                            >
                                Edit
                            </button>
                            <button
                                className='actBtn billBtn noWidth'
                                onClick={() => {
                                    setRowClickId(faqdata._id);
                                    setDeleteModal(true);
                                }}
                            >
                                Delete
                            </button>
                        </div>
                    )}
                </div>
            ))}
            {deleteModal && (
                <Dialog openModal={deleteModal} heading={'Delete Confirmation!'}>
                    <div className='dialogContent'>
                        <p className='confirmationText'>Are you sure?</p>
                        <p className='confirmationMessage'>You want to delete this data.</p>
                        <div className='alignCenter'>
                            <button className='dialogActBtn submit' onClick={() => handleDelete(rowClickId)}>
                                Yes
                            </button>
                            <button
                                className='dialogActBtn cancel'
                                onClick={() => {
                                    setDeleteModal(false);
                                    setRowClickId(0);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </div>
    );
}
